export default {
  surveyLinkExhibitorDirectory: 'https://app.ballparkhq.com/share/self-guided/xD4JdTkAokejHstNB8X4eH',
  surveyLinkHub: null,
  localAgainstShow: {
    eventEditionIdsToExclude: ["eve-d95a3822-646c-45b7-8d3e-a8d1e34bbb55"],
    eventIdsToExclude: []
  },
  preprod: {
    eventEditionIdsToExclude: ["eve-7d50f206-6bd8-46ec-ad12-34b12760a7ef", "eve-6ec461c3-829d-4bd3-8436-827c634162d0"],
    eventIdsToExclude: ["evt-6fea1e52-9e5c-44b9-b85a-aa566f4afa1b"]
  },
  prod: {
    eventEditionIdsToExclude: ["eve-10bc3b35-320d-4b88-a577-08149c81a02f"],
    eventIdsToExclude: [ "evt-1aafcc50-e1bd-4fb8-9f3e-5668b885277c" ]
  }
};